fragment AllocationProjectFragment on AllocationProject {
  id
  allocationName
  startDate
  allocationDate
  prefillOption
  orgStructurePITOption
  baselineDate
  isActive
  forecast
  workingDays
  isRequestorPlannerReadonly
  requestorPlannerReadonlyBanner
  requestorPlannerReadonlyHover
  isApproverPlannerReadonly
  approverPlannerReadonlyBanner
  approverPlannerReadonlyHover
  shouldVerifyObjectives
  disablePlannerRequirementInput
  disablePrefillFutureForecastFromPrevious
  enableRequirementInput
  enableDecimalFTEInput
  enableRequestorForecastConstraint
  enableApproverForecastConstraint
  enableRealtimeAllocation
  announcements {
    isActive
    messageType
    startDate
    endDate
    content
    description
  }
  isRequestorForecastReadonly
  requestorForecastReadonlyBanner
  requestorForecastReadonlyHover
  isApproverForecastReadonly
  approverForecastReadonlyBanner
  approverForecasteadonlyHover
  forecastBudgetColumnName
  forecastBudgetColumnTooltip
  forecastBudgetDeltaColumnName
  forecastBudgetDeltaColumnTooltip
  baselineColumnName
  baselineColumnTooltip
  requestorColumnName
  requestorColumnTooltip
  approverColumnName
  approverColumnTooltip
}


fragment AllocationConfigFragment on AllocationConfig {
  requestorTypes
  approverTypes
  roleTypes
  targetTypes
  demandLabel
  supplyLabel
  approvalReasons
  enableFinancialForecasting
  financialYear
  overBudgetLimit
  underBudgetLimit
  hideBudgetColumn
  hideBudgetTooltip
  enableForecastSearchView
  forecastSearchOptions
  forecastSearchInvalidTags
  forecastSearchLimit
  enableForecastSubmitting
  showAllBudgetTargetGroups
  enableForecastConstraints
  enableMembersInForecast
  enableMembersInPlanner
  enablePlannerTargets
  enableAddNewRole
  enableAddNewRoleInForecast
  showMemberMoveBadge
  showMemberTags
  showObjectives
  hideHiddenTeams
  enableAddVacantRole
  enableVacantRoleWithUpdate
  vacantRoleLabel
  currentMemberFteLabel
  totalChangeLabel
  macroAllocationDeltaFteLabel
  desiredInputAsDelta
  enableMemberFteEdit
  enableMacroAllocationPerspective
  enableDeparturedPeopleTagEditing
  enableBulkAddingTag
  enableWorkspaceAccess
  enableWorkspaceAccessForEveryone
  enableWorkspaceAccessForAllowList
  enableBulkMoveMembers
  enableBulkDeallocations
  enableBulkMoveWithUpdate
  enablePlannerBudgetTarget
  useDeltaForBudget
  enableMemberAllocation
  enableAddMember
  enableMembersFilter
  enableChangeSupplyGroup
  allocateBtnLabel
  hideAllocateButton
  moveMemberBtnLabel
  addTeamBtnLabel
  groupDetailsLabelSuffix
  groupingLineItemsLabel
  groupingTagsLabel
  initalExpansionLevel
  hideApproverColumn
  enableSearchView
  enableSetGroupTags
  plannerSearchOptions
  plannerSearchInvalidTags
  plannerSearchLimit
  plannerOverBudgetLimitPercentage
  plannerUnderBudgetLimitPercentage
  enableTagAttributes
  enableTagsAppliedCount
  enableMoveGroups
  enableGroupAccessRestrictions
  groupAccessUnauthorisedTitle
  groupAccessUnauthorisedDescription
  groupAccessUnauthorisedShowBackButton
  groupAccessUnauthorisedShowSupportButton
  groupAccessUnauthorisedShowLogoutButton
  disableGroupPrinciples
  disableGroupPlanner
  disableGroupForecast
  disableGroupTeamBuilder
  disableGroupInsights
  disableGroupHistory
  disableIndividualAllocation
  disableGroupStrategy
  hideDirectReports
  hideWorksWith
  showInlineBreadcrumbsInForecast: switchToLoadSupplyGroups
  enableSavingZeroFteAgainstIndividuals
  enablePastAllocationEdits
  pastAllocationEditsMaxDaysBack
  pastAllocationEditsCutoffDate
  enableAllocationFteCap
  showMacroAllocationInput
  plannerTabName
  strategyButtonLabel
  strategyPlaceholderText
  strategyPlaceholderLinks
  strategyInfoBannerText
  strategyExcludedStatusTypes
  forecastTabName
  forecastAIPrompt
  constraintLabel
  totalLabel
}


fragment PartialGroupFragment on Group {
  id
  name
  type
}


fragment StrategyConfigFragment on StrategyConfig {
  nodeConfigs {
    type
    visible {
      goalsExplorerRoot
    }
  }
}



fragment FullWorkspaceFragment on Workspace {
  id
  name
  description
  config {
    tenantConfig
    allocation {
      ...AllocationConfigFragment
    }
    groupTypes
    fteConfig {
      decimal
      currencySymbol
    }
    locale
    customer
    configType
    tagTypes {
      all
      group
      groupBadge
      person
    }
    tagConfig
    featureFlags
    helpConfig {
      customHelpMenuTitle
      customHelpMenuDescription
      showTeamFormSupportRequest
      showTeamFormHelpContent
      showCustomHelpContent
      externalContents {
        title
        description
        href
        type
        iconUrl
        locations
        roles
      }
    }
    workspaceDatabaseConfig {
      web {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
      webInsights {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
      webMacroAllocations {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
      batch {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
      clone {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
      publicApi {
        generalSqlCachingEnabled
        specialSqlCachingEnabled
        randomPageCost
        maxLimit
        poolConnectionCount
        similarityThreshold
        statementTimeoutMs
        transactionIdleTimeoutMs
        lockTimeoutMs
        workerCount
        workingMemoryMb
        maintenanceWorkerMemoryMb
        maintenanceWorkerCount
      }
    }
    clones {
      id
      progress
      created
      processed
      status
      error
      cloneWorkspaceId
    }
    notifications
    emailNotificationConfig
    emailNotificationBatch
    strategy {
      ...StrategyConfigFragment
    }
  }
  isActive
  isReportingEnabled
  rootGroups {
    ...PartialGroupFragment
  }
}

fragment PartialWorkspaceFragment on Workspace {
  id
  name
  description
  created
  isActive
  isReportingEnabled
}

fragment ManagementWorkspaceFragment on Workspace {
  id
  name
  description
  created
  isActive
  isReportingEnabled
  lastReportingTime
  lastTransactionTime
}

# Extended fragment for workspace settings pages - includes custom help/links config
# Only use this fragment in settings pages, not in the main app context
# helpConfig is now a typed GraphQL object (stored as JSON blob in backend)
fragment WorkspaceHelpConfigFragment on Workspace {
  id
  name
  config {
    helpConfig {
      customHelpMenuTitle
      customHelpMenuDescription
      showTeamFormSupportRequest
      showTeamFormHelpContent
      showCustomHelpContent
      externalContents {
        title
        description
        href
        type
        iconUrl
        locations
        roles
      }
    }
  }
}


fragment GroupPermissionsFragment on GroupPermissions {
  areGroupsInAccessGroupIdsHierarchy
  updateGroupAttributes
}



fragment UserPersonFragment on Person {
  address
  country
  city
  aggregateId
  employeeId
  allocations {
    fte
    targetGroupId
  }
  attributes {
    attributeType
    subtype
    value
  }
  avatar
  bands
  company
  fte
  jobTitle
  firstName
  surname
  preferredName
  layers
  span
  division {
    id
    name
    hierarchy
  }
  memberOf {
    id
    parentIds
    name
    type
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      ...GroupPermissionsFragment
    }
    tags {
      id
      type
      displayValue
      isActive
      attributes
    }
  }
  accessGroups {
    id
    name
    type
    parentIds
    hierarchyIds
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
    permissions {
      ...GroupPermissionsFragment
    }
  }
  tags: appliedTags {
    id
    tagId
    type
    displayValue
    isActive
  }
  sourceGroupIds
  permissions {
    isInAccessGroupIdsHierarchy
  }
}


# Minimal variant for allocation search - avoids managedByHierarchy.avatar/jobTitle
fragment PersonManagersTagsMinimalFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}

fragment PersonManagersTagsFragment on Person {
  managedBy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
    attributes {
      attributeType
      subtype
      value
    }
  }
  managedByHierarchy {
    firstName
    surname
    preferredName
    aggregateId
    avatar
    jobTitle
  }
  tags: appliedTags {
    displayValue
    id
    isActive
    tagId
    type
  }
}



query getContext($isRestricted: Boolean!) {
  allocationProject: getAllocationProject @skip(if: $isRestricted) {
    ...AllocationProjectFragment
  }
  oldestPersonIndexDate: getOldestPersonIndexDate @skip(if: $isRestricted)
  version: getVersion
  maintenanceMode: getMaintenanceMode
  userPerson: getPersonForUser {
    ...UserPersonFragment
    ...PersonManagersTagsFragment
  }
  importDate: getLatestImportDate @skip(if: $isRestricted)
}

query getActiveWorkspace {
  activeWorkspace: getActiveWorkspace {
    ...FullWorkspaceFragment
  }
}

query getWorkspace($id: ID!, $includeReportingInfraProvisioned: Boolean!) {
  workspace: getWorkspace(id: $id) {
    ...FullWorkspaceFragment
  }
  isReportingInfraProvisioned: getReportingInfraProvisioned(workspaceId: $id)
    @include(if: $includeReportingInfraProvisioned)
}

query getWorkspaces {
  workspaces: getWorkspaces {
    ...PartialWorkspaceFragment
  }
}

query getReportingResourceCreationStatus($workspaceId: ID!) {
  status: getReportingResourceCreationStatus(workspaceId: $workspaceId)
}
